import {NgModule} from '@angular/core';
import {CategorySelectComponent} from './category-select.component';
import {CategorySelectPopoverComponent} from './category-select-popover.component';
import {PagesSharedModule} from '../../../pages/pages-shared.module';

@NgModule({
    imports: [
        PagesSharedModule
    ],
    declarations: [
        CategorySelectComponent,
        CategorySelectPopoverComponent,
    ],
    entryComponents: [
        CategorySelectPopoverComponent,
    ],
    exports: [
        CategorySelectComponent,
    ]
})
export class CategorySelectModule {
}
